// extracted by mini-css-extract-plugin
module.exports = {"label":"TabLabel_label__2nipi","label--selected":"TabLabel_label--selected__3RWel"};